import { useState }	from 'preact/compat';

function useScrollBlock() {
	const [scrollBlocked, setScrollBlocked] = useState(false);

	const blockScroll = () => {
		document.body.style.position = 'relative';
		document.body.style.overflow = 'hidden';
	}

	const allowScroll = () => {
		document.body.style.position = '';
		document.body.style.overflow = '';
	}

	return { scrollBlocked, setScrollBlocked, blockScroll, allowScroll }
}
export default useScrollBlock;